module.exports = __webpack_public_path__ + "static/img/logo-alt.f04a6721.svg";